import React from "react";
import { StandardPageWrapper } from "../../../../components/layout/StandardPageWrapper";
import {
  ProgressFooter,
  ProgressFooterActions,
  ProgressFooterSaveNotification,
} from "../../../get-compliant/ProgressFooter";
import { HRDataMapTabKey, HRDataMapTabs } from "./HRDataMapTabs";
import { usePrimaryOrganizationId } from "../../../../hooks";
import { DEVELOPER_INSTRUCTIONS_SURVEY_NAME } from "../../PrivacyNoticeChecklistItems";
import { useSurvey } from "../../../../../common/hooks/api/useSurvey";
import { DevInstructionsFinishedHrDataMapSlug } from "../HRCenterDashboardPage";
import { MutationOrNetworkState } from "../../../../../common/models/NetworkRequest";
import { Breadcrumbs } from "@truevault/aquilo";
import { Routes } from "../../../../root/routes";

export function EmployeePageWrapper({
  selectedTabKey,
  alwaysShowFooter,
  nextOnClick,
  nextContent,
  nextDisabled,
  nextDisabledTooltip,
  isSaving,
  saveRequest,
  children,
}: {
  selectedTabKey: HRDataMapTabKey;
  alwaysShowFooter?: boolean;
  nextOnClick: () => void;
  nextContent?: string;
  nextDisabled: boolean;
  nextDisabledTooltip?: string;
  isSaving?: boolean;
  saveRequest?: MutationOrNetworkState | MutationOrNetworkState[];
  children: React.ReactNode;
}) {
  const orgId = usePrimaryOrganizationId();
  const { answers: devInstructionsSurveyAnswers } = useSurvey(
    orgId,
    DEVELOPER_INSTRUCTIONS_SURVEY_NAME,
  );

  const isFinishedWithHrDataMap =
    devInstructionsSurveyAnswers[DevInstructionsFinishedHrDataMapSlug] === "true";

  return (
    <StandardPageWrapper
      fullWidth
      footer={
        (!isFinishedWithHrDataMap || alwaysShowFooter) && (
          <ProgressFooter
            content={isSaving && <ProgressFooterSaveNotification request={saveRequest} />}
            actions={
              <ProgressFooterActions
                nextContent={nextContent || "Next"}
                nextOnClick={nextOnClick}
                nextDisabled={nextDisabled}
                nextDisabledTooltip={nextDisabledTooltip}
              />
            }
          />
        )
      }
    >
      <div className="tw-boundary" style={{ marginBottom: "60px" }}>
        <Breadcrumbs title="Data Map" source="HR Center" sourceRoute={Routes.hrCenter.root} />

        <HRDataMapTabs
          selectedTabKey={selectedTabKey}
          enableNextTab={!nextDisabled}
          enableAllTabs={isFinishedWithHrDataMap}
        />
      </div>

      {children}
    </StandardPageWrapper>
  );
}
